module.exports = __webpack_public_path__ + "img/fatima-akram-uU0Anw-8Vsg-unsplash.c41d70eb.jpg";